import React from 'react'
import StatusTable from './StatusTable'

export default function CategoryStatus() {
  const tableData = (item) => {
    return [
      { image: item.image, type: 'IMAGE' },
      { value: item.name },
      { value: item.categoryCode },
      { value: item.description },
      { value: item.remark ? item.remark : '-----' },
      { type: 'STATUS_ENUM', status: item.status },
    ]
  }
  return <StatusTable key="Category" tableHeading={['image', 'name', 'category code', 'description', 'reason', 'status']} tableData={tableData} module="CATEGORY" />
}
